/* @jsx h */
import { defineComponent, h } from "vue";
import { LoyaltyWalletDesignsPage } from "../../../../ManagerPromotions/subpages/WalletDesigns";
import { useGroupAuth } from "@app/vue/providers/GroupAuth";

export const GroupWalletDesignsPage = defineComponent({
  name: "GroupWalletDesignsPage",
  setup() {
    const auth = useGroupAuth();
    return () => (
      <LoyaltyWalletDesignsPage
        scope="group"
        canManage={auth.isGroupAdmin.value}
      />
    );
  },
});
